import React, { useState, useEffect } from "react";
import Classes from "./styles/style.module.css";
import { Link, useLocation } from "react-router-dom";

const padWithZero = (number) => {
  return number < 10 ? `0${number}` : number;
};

const Banner = (props) => {
  const calculateTimeLeft = () => {
    if (!props.date) return null;
    const difference = +new Date(props.date) - +new Date();
    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return null;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [showDate, setShowDate] = useState(false);

  useEffect(() => {
    if (!timeLeft) return;
    const timer = setTimeout(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  useEffect(() => {
    const difference = +new Date(props.date) - +new Date();
    if (!difference || difference <= 0) setShowDate(true);
    return () => setShowDate(false);
  }, [timeLeft]);

  const { pathname } = useLocation();

  const isExternal = /^https?:\/\//i.test(props.href);

  const handleClick = (e) => {
    if (isExternal) {
      e.preventDefault();
      if (props.linkNewTab) {
        window.open(props.href, "_blank");
      } else {
        window.location.href = props.href;
      }
    }
  };

  const BannerContent = (
    <div className={Classes.mainContainer}>
      {props.glow && <div className={Classes.border}></div>}
      <div
        className={Classes.bannerWrapper}
        style={{
          padding: props.glow ? "2px" : 0,
          border:
            pathname === "/hubble" ? "2px solid var(--hubblePurple)" : "none",
          borderRadius: "17px",
        }}
      >
        <div
          className={`${Classes.bannerContainer} ${
            props.topbanner ? Classes.topBanner : ""
          }`}
        >
          <img src={props.src} />
          <h5>{props.title}</h5>
          {props.showText && (
            <div className={Classes.textContainer}>
              <p>{props.title}</p>
            </div>
          )}
        </div>
        {props.date && !showDate ? (
          <div className={Classes.dateContainer}>
            <div className={Classes.dateLabel}>{props.dateLabel}</div>
            <div className={Classes.date}>
              <div
                className={`${Classes.dateTextAndTitle} ${Classes.dayContainer}`}
              >
                <p>{timeLeft ? timeLeft.days : "0"}</p>
                <p className={Classes.sub}>روز</p>
              </div>
              <div className={Classes.dateTextAndTitle}>
                <p>{timeLeft ? padWithZero(timeLeft.hours) : "00"}</p>
                <p className={Classes.sub}>ساعت</p>
              </div>
              <div>
                <p>:</p>
              </div>
              <div className={Classes.dateTextAndTitle}>
                <p>{timeLeft ? padWithZero(timeLeft.minutes) : "00"}</p>
                <p className={Classes.sub}>دقیقه</p>
              </div>
              <div>
                <p>:</p>
              </div>
              <div className={Classes.dateTextAndTitle}>
                <p>{timeLeft ? padWithZero(timeLeft.seconds) : "00"}</p>
                <p className={Classes.sub}>ثانیه</p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );

  if (isExternal) {
    return (
      <a
        href={props.href}
        target={props.linkNewTab ? "_blank" : "_self"}
        onClick={handleClick}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {BannerContent}
      </a>
    );
  }

  return (
    <Link to={props.href} target={props.linkNewTab ? "_blank" : "_self"}>
      {BannerContent}
    </Link>
  );
};

export default Banner;
